export const progressBarMetadata = {
  allowConnectToDB: true,
  resizableDiagonally: false,
};
